// extracted by mini-css-extract-plugin
export default {"box":"filterPage_box__jCnE5","box__content":"filterPage_box__content__KLL4e","box__btn":"filterPage_box__btn__+mkaF"};